<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        SQL execute
        <small>Type and execute SQL</small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content">
      <div class="  ">
          <div class="form-inline">
              <div class="form-group query-input">
                  <input v-model="state" type="text" class="form-control" placeholder="Type your query..." id="query">
              </div>
              <button @click="executeSQL()" type="button" class="btn btn-primary pull-right">Execute</button>
          </div>
          <br />
          <div v-show="status == -1 && msg != ''"class="alert-error">
              {{ msg }}
          </div>
          <div v-show="status == 1 && msg != ''"class="alert-success">
              {{ msg }}
          </div>
      </div>
      <br />
        <div class="results">
            <div class="table-responsive">
            <table v-if="resultLength > 0" class="table table-striped">
                <thead>
                <tr>
                    <th v-for="(value, propertyName) in result[0]">{{ propertyName }}</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="row in result">
                        <td v-for="(value, propertyName) in row">{{ decoded(value) }}</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'SQL',
    data: function () {
      return {
        state: '',
        role: 1,
        result: [],
        resultLength: 0,
        searching: 0,
        form: new Form({}),
        msg: '',
        status: 0,
        localStorageQueries: '',
        ipinfo: {
          'city': '',
          'country': '',
          'region': '',
          'isp': '',
          'status': ''
        }
      }
    },
    computed: {
    },
    methods: {
      executeSQL: function () {
        console.log('executing: ' + this.state)
        if (this.state === '') {
          this.msg = 'Enter SQL state'
          this.status = -1
          return 0
        }
        var self = this
        this.searching = 1
        this.status = 0
        let data = {
          state: this.state,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        self.result = []
        self.resultLength = 0
        this.msg = ''
        this.form.post(baseUrl + 'Admin/executeSQL', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.result = result.data.slice()
            self.resultLength = self.result.length
            self.msg = result.query
            self.status = 1
          } else {
            self.msg = result.msg
            self.status = -1
          }
          self.searching = 0
        }, function (reason) {
          // rejection
          self.msg = reason
          self.status = -1
        })
      },
      decoded: function (encoded) {
        if (encoded === '') {
          return ''
        }
        try {
          return decodeURI(encoded)
        } catch (err) {
          return encoded
        }
      },
      saveLocalQueries: function () {
        localStorage.setItem('savedQueries', this.localStorageQueries)
        $('#myModal').modal('close')
      },
      getIpInfo: function (ip) {
        var self = this
        self.ipinfo = {}
        this.form.post('https://ipapi.co/' + ip + '/json/', {}).then(function (result) {
          self.ipinfo['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal']
          self.ipinfo['country'] = result['country_name']
          self.ipinfo['region'] = result['region']
          self.ipinfo['isp'] = result['org']
          self.ipinfo['status'] = true
        }, function (reason) {
          // rejection
        })
      }
    },
    mounted: function () {
      this.role = this.$store.state.role
      var self = this

      if (Number(this.$store.state.role) < 40) {
        this.$router.push('/dashboard')
      }
      window.$ = $
      if (localStorage.savedQueries) {
        self.localStorageQueries = localStorage.savedQueries
      }
    }
  }
</script>

<style scoped>

  @media screen and (min-width: 768px) {
      .query-input {
          width: calc( 100% - 88px );

      }
      .query-input input {
          display: block;
          width: 100%;
      }

  }
  @media screen and (max-width: 992px) {
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 480px) {
  }
</style>



// WEBPACK FOOTER //
// SQL.vue?6b00a3e4